import type { AdminCaseSummary } from '@casetrace/shared';
import { AdminCaseCard } from './admin-case-card';

interface AdminCasesSectionProps {
  cases: readonly AdminCaseSummary[];
}

export function AdminCasesSection({ cases }: AdminCasesSectionProps) {
  return (
    <section className="space-y-3 rounded-lg border border-white/[0.07] bg-surface p-4">
      <div className="flex items-center justify-between">
        <h2 className="text-sm font-semibold text-text-primary">Saker og kilder</h2>
        <span className="text-xs text-text-tertiary">{cases.length} saker</span>
      </div>
      <div className="space-y-3">
        {cases.map((caseSummary) => (
          <AdminCaseCard key={caseSummary.case.id} summary={caseSummary} />
        ))}
      </div>
    </section>
  );
}
